import React from 'react';
import VideoPage from '../../components/video-page';
import Custom404 from '../404';

import { GetStaticPaths, GetStaticProps } from 'next';
import { getAllPostsWithSlug, getPostAndMorePosts, getPrimaryMenuItems } from '../../lib/api';
import { IMenuItem } from '../../models/menu-item';
import { ISponsor } from '../../models/sponsor';
import { IPostDirect } from '../../models/post';

interface IProps {
	primaryMenuItems: IMenuItem[];
	post: IPostDirect;
	sponsors: ISponsor[];
}

export default function Video({ primaryMenuItems, post, sponsors }: IProps) {
	if (post.videoLinks) {
		return <VideoPage data={post} primaryMenuItems={primaryMenuItems} sponsors={sponsors} />
	}

	return <Custom404 sponsors={sponsors} primaryMenuItems={primaryMenuItems} />;
}

export const getStaticProps: GetStaticProps = async ({ params, preview = false, previewData }) => {
	const { post, sponsors } = await getPostAndMorePosts(params?.slug as string, preview, previewData);

	if (!post) {
		return {
			redirect: {
				destination: '/video',
				statusCode: 302,
			},
		};
	}

	const primaryMenuItems = await getPrimaryMenuItems();

	return {
		revalidate: 300,
		props: {
			sponsors: sponsors.nodes,
			post,
			primaryMenuItems,
		},
	};
};

export const getStaticPaths: GetStaticPaths = async () => {
	const allPosts = await getAllPostsWithSlug();

	const mappedPaths = allPosts.posts.edges.map(({ node }) => `/video/${node.slug}`);

	return {
		paths: mappedPaths,
		fallback: 'blocking',
	};
};
